import { ContentType } from '@mode/notebooks/contract';
import { createAction, props } from '@ngrx/store';

export const editCellContent = createAction('[Cell] EditCellContent', props<{ content: string; cellToken: string }>());
export const beginEditCell = createAction('[Cell] BeginEdit', props<{ cellToken: string; cellFrozen: boolean }>());
export const UpdateContentType = createAction(
  '[Cell] UpdateContentType',
  props<{ contentType: ContentType; cellToken: string }>()
);
